import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import * as toastr from 'toastr';

import policyActions from '../../../policy/policyActions';
// import Utils, { UtilsBeneficiaries, BeneficiaryTypes } from '../../../common/utils';
// import { defaultTrustee } from '../../../policy/policyAPI';
import { Button } from '../../../components/buttons';
import { IconChevronRight } from '../../../components/icons';
import OptionalBeneficiaryPage from './OptionalBeneficiaryPage';
import OptionalBeneficiaryDisbursementPage from './OptionalBeneficiaryDisbursementPage';
import WorkflowStep from '../../WorkflowStep';

interface Props {
	// passed props
	actions: any;
	history: any;
	match?: any;
	hidden: boolean;

	// redux props
	customer: UserDetails;
	customerPolicy: CustomerPolicy;
}

interface State {
	currentStep: number;
	isLoading: boolean;
	allowToSkip: boolean;
}

class OptionalBeneficiaryContainer extends React.Component<Props, State> {
	lastStep = 2;
	constructor(props: Props) {
		super(props);
		this.state = {
			currentStep: this.getStep(),
			isLoading: false,
			allowToSkip: true
		};
	}

	getStep() {
		var step = parseInt(location.hash.replace('#', ''), 10);
		if (!isNaN(step)) {
			return step;
		}
		return 1;
	}

	componentDidUpdate(prevProps: Props, prevState: State) {
		if (this.state.currentStep !== prevState.currentStep) {
			location.hash = this.state.currentStep.toString();
		}
	}

	goToExistingBeneficiary = () => {
		this.setState({ currentStep: 1 });
		return this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/beneficiary`);
	}

	nextStep = (e: any) => {
		let currentStep = this.state.currentStep;
		if (currentStep === this.lastStep) {
			return this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/billing`);
		} else {
			currentStep++;
			this.setState({ ...this.state, currentStep: currentStep });
		}
	}

	skip = () => {
		return this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/billing`);
	}

	hideSkipButton = () => {
		this.setState({ allowToSkip: false });
	}

	render() {
		let currentBeneficiaryComponent = null;
		switch (this.state.currentStep) {
			case 1:
				currentBeneficiaryComponent = (
					<OptionalBeneficiaryPage
						{...this.props}
						nextStep={this.nextStep}
						hidden={false}
						hideSkipButton={this.hideSkipButton}
					/>
				);
				break;
			case 2:
			default:
				currentBeneficiaryComponent = (
					<OptionalBeneficiaryDisbursementPage
						{...this.props}
						nextStep={this.nextStep}
						hidden={false}
						goToExistingBeneficiary={this.goToExistingBeneficiary}
					/>
				);
				break;
		}
		
		return (
			<WorkflowStep>
				{currentBeneficiaryComponent}
				{this.state.currentStep !== this.lastStep && this.state.allowToSkip &&
					<div className="workflow-progress-actions">
						<Button
							onClick={this.skip}
							className="btn-outline-primary workflow-progress-action"
							disabled={this.state.isLoading}
						>
							<span className="align-middle mx-2">Skip</span>
							<IconChevronRight/>
						</Button>
					</div>}
			</WorkflowStep>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		customer: state.user.user,
		customerPolicy: state.policy.customerPolicy
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(OptionalBeneficiaryContainer);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/billing-review/OptionalBeneficiaryContainer.tsx